import React from 'react';
import styled from 'styled-components';

const TimePickerContainer = styled.div`
  width: 100%;
  margin: 1rem 0;
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  font-size: 1rem;
  color: #333;
  margin-bottom: 0.5rem;
`;

const TimeInput = styled.input`
  padding: 0.8rem;
  font-size: 1rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: white;
  color: #333;
  box-shadow: 0 0 8px rgba(102, 187, 106, 0.2);

  &:focus {
    border-color: #66bb6a;
    outline: none;
  }

  /* Adjust width and font size for mobile */
  @media (max-width: 768px) {
    font-size: 1rem;
    padding: 0.6rem;
  }
`;

const TimePicker = ({ label, value, onChange }) => {
  return (
    <TimePickerContainer>
      {label && <Label>{label}</Label>}
      <TimeInput
        type="time"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </TimePickerContainer>
  );
};

export default TimePicker;
